import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { updateLocation } from '../store/router/actions';

const RouterListener = () => {
    const { pathname, search, hash } = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            updateLocation({
                pathname,
                search,
                hash,
            })
        );
    }, []);

    useEffect(() => {
        dispatch(
            updateLocation({
                pathname,
                search,
                hash,
            })
        );
    }, [dispatch, pathname]);

    return null;
};

export default RouterListener;
